export const getRegistrationNumberRegex = (countryId = 'DK') => {
  switch (countryId) {
    case 'NL':
      // KVK -> 8 digits
      return /^\d{8}$/
    case 'DE':
      // Steuernummer -> 10 or 11 digits or format like 12/345/67890 or 123/456/99999
      return /^(\d{10,13}|\d{2,3}\/\d{3,4}\/\d{3,5})$/
    case 'FR':
      // SIRET -> 14 digits
      return /^\d{14}$/
    default:
      // For other countries, no specific format is enforced
      return /.*/
  }
}
